"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAttributedDownloadUrl = void 0;
const downloadLink = "https://www.snapchat.com/download/";
// The query param used with downloadLink
const sourcePageParam = "sp";
const purposeParam = "purpose=web_stories";
// Generates the link for the Snapchat download page
// e.g. https://www.snapchat.com/download?purpose=web_stories&sp=not_found.
// We use PageLinks.downloadUrl for the download link whenever possible. This is currently used only
// on a few pages eg, NotFound and NotAvailable where we don't populate pageLinks on the server yet.
// TODO: Use the backend code for the download page URL generation
// https://github.sc-corp.net/Snapchat/content-platform/blob/main/web-stories/conversions/src/main/scala/snapchat/web/stories/conversions/DownloadLink.scala
// This is the source of truth
const generateAttributedDownloadUrl = (pageType) => {
    const sourcePage = pageType.toString().toLowerCase();
    return `${downloadLink}?${purposeParam}&${sourcePageParam}=${sourcePage}`;
};
exports.generateAttributedDownloadUrl = generateAttributedDownloadUrl;
//# sourceMappingURL=downloadUrlGenerator.js.map